import React, { useState } from "react";
import Recently_added_dropdown from "../dropdown/recently_added_dropdown";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";

const Collection_category_filter_details = ({item, name, rarity}) => {
  return (
    <>
     <div className={`dark:hover:bg-jacarta-600 dark:text-jacarta-200 hover:bg-jacarta-50 flex items-center justify-between rounded-xl px-4 py-2 ${item?.includes(name)? "bg-jacarta-600": ""}`}>
      <span>{name}</span>
      <span>{rarity}</span>
    </div>
    </>
  );
};

export default Collection_category_filter_details;
